import BaseComponent from "./base-component";
import {dashToCamel, parseAttribute} from "../util/attribute-parser";

const html = function (strings, ...keys) {
    const lastIndex = strings.length - 1;
    return strings
            .slice(0, lastIndex)
            .reduce((p, s, i) => p + s + keys[i], '')
        + strings[lastIndex];
};

class TemplateComponent extends BaseComponent {
	// we need to stop requesting updates for childlist mutations because they will trigger when we render the template :(
	defineObserver() {
		// see: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver#Example_usage
		this._mutationObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.type === 'attributes' &&
					mutation.target === this.element &&
					this._state.hasOwnProperty(dashToCamel(mutation.attributeName))
				) {
					// update property by invoking the setter
					this.element[dashToCamel(mutation.attributeName)] = parseAttribute(
						this.element.getAttribute(mutation.attributeName),
					);
				}
				if (mutation.type === 'attributes' && mutation.target !== this.element) {
					this.requestUpdate();
				}
				if (mutation.type === 'childList') {
					//this.requestUpdate();
				}
			});
		});

		this._mutationObserver.observe(this.element, {
			attributes: true,
			childList: true,
			subtree: false,
		});
	}

	update() {
        this.render();
        super.update();
    }

    render() {
        this.element.innerHTML = this.template();
    }

    template() {
        return html``;
    }
}

export default TemplateComponent;
export {TemplateComponent, BaseComponent, html}
